/**
 * RELATÓRIO DE ESTOQUE — as 5 abas da §7.3: Posição, Giro e cobertura,
 * Ruptura, CMV e Ficha técnica.
 *
 * O QUE ESTAVA AQUI ANTES: um card vazio de 16 linhas, com um ícone e o título
 * "Relatório de Materiais". Nenhuma tabela, nenhum dado.
 *
 * O QUE ESTÁ AQUI AGORA, e por que não é mais do que isto: as 5 abas existem,
 * com as colunas que cada uma vai ter, TODAS VAZIAS E EXPLICADAS. Não existe
 * tabela de movimento de estoque em nenhum dos dois bancos — sem movimento não
 * há saldo, e sem saldo não há posição, giro, ruptura, CMV real nem margem.
 *
 * Preencher com zero seria mais bonito e seria mentira: zero diz "contei seu
 * estoque e deu R$ 0,00". O painel de bloqueio mostra o diagnóstico MEDIDO (as
 * contagens vêm do catálogo do Postgres, na hora), então no dia em que a tabela
 * nascer a tela para de dizer que falta sozinha.
 *
 * É o oposto explícito do `Math.random()` do Dashboard.
 *
 * SÓ LEITURA (§5.1).
 */
import React from "react";
import { useSearchParams } from "react-router-dom";
import * as AlfredoStyles from "../styles/components/SupplyReport";
import * as EstilosDeRelatorio from "../styles/components/reports/RelatorioComum";
import * as AlfredoComponents from "./";
import { relatorioService } from "../services/relatorio.service";
import { useRelatorio } from "../hooks/useRelatorio";

const CAMPOS = ["de", "ate", "aba"];

const buscarEstoque = relatorioService.estoque.bind(relatorioService);

const SupplyReport: React.FC = () => {
  const [parametrosDaUrl] = useSearchParams();
  const abaAtual = parametrosDaUrl.get("aba") || "posicao";

  const relatorio = useRelatorio(buscarEstoque, CAMPOS);
  const abas = relatorio.envelope?.abas ?? [];

  return (
    <AlfredoStyles.LastOptionsContainer>
      <AlfredoStyles.Card>
        <AlfredoStyles.Icon>inventory_2</AlfredoStyles.Icon>
        <AlfredoStyles.Title>Relatório de Estoque</AlfredoStyles.Title>

        <AlfredoComponents.CarimboDoDado
          carimbo={relatorio.envelope?.carimbo}
          fonte={relatorio.envelope?.fonte}
          semVenda
        />

        {abas.length > 0 && (
          <EstilosDeRelatorio.Abas>
            {abas.map((aba) => (
              <EstilosDeRelatorio.Aba
                key={aba.id}
                type="button"
                ativa={aba.id === abaAtual}
                onClick={() => relatorio.mudarFiltro("aba", aba.id)}
              >
                {aba.titulo}
              </EstilosDeRelatorio.Aba>
            ))}
          </EstilosDeRelatorio.Abas>
        )}

        <AlfredoComponents.AvisosDoRelatorio avisos={relatorio.envelope?.avisos} />

        {/* O painel vem ANTES da tabela: a explicação é a informação desta
            tela, e a tabela vazia é só a prova de que as colunas existem. */}
        <AlfredoComponents.EstadoBloqueado dados={relatorio.envelope?.bloqueado} />

        <AlfredoComponents.DynamicTable
          tableType={0}
          handleOpenModal={() => undefined}
          rows={relatorio.linhas}
          columns={relatorio.colunas}
          getRowId={(linha) => String(linha.chave ?? "")}
          title={
            abas.find((aba) => aba.id === abaAtual)?.titulo ?? "Estoque"
          }
          hideCreateButton
          hideImportButton
          hideRowActions
          isLoading={relatorio.carregando}
          error={relatorio.erro}
          emptyMessage="Sem insumo para esta aba — o motivo de cada coluna está acima. Nenhum número foi fabricado."
        />

        {relatorio.envelope && (
          <AlfredoComponents.RodapeDaFonte envelope={relatorio.envelope} />
        )}
      </AlfredoStyles.Card>
    </AlfredoStyles.LastOptionsContainer>
  );
};

export default SupplyReport;
